export const polarToCartesianCoordinates = (cX, cY, rad, angleInDegrees) => {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

  return {
    x: cX + rad * Math.cos(angleInRadians),
    y: cY + rad * Math.sin(angleInRadians),
  };
};

export const pathForSemiCircularSvg = (x, y, rad, startAngle, endAngle) => {
  const start = polarToCartesianCoordinates(x, y, rad, endAngle);
  const end = polarToCartesianCoordinates(x, y, rad, startAngle);

  const path = [
    `M ${start.x} ${start.y}`,
    `A ${rad} ${rad} 0 ${endAngle - startAngle <= 180 ? '0' : '1'} 0 ${end.x} ${
      end.y
    }`,
  ].join(' ');

  return path;
};
